import { render, staticRenderFns } from "./DangerousGoodsPage.vue?vue&type=template&id=2d8f5762&scoped=true&"
import script from "./DangerousGoodsPage.vue?vue&type=script&lang=js&"
export * from "./DangerousGoodsPage.vue?vue&type=script&lang=js&"
import style0 from "./DangerousGoodsPage.vue?vue&type=style&index=0&id=2d8f5762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f5762",
  null
  
)

export default component.exports